import React, {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import {useDispatch} from "react-redux";

import _ from "lodash";

import {GOOGLE_RECAPTCHA_KEY, URL_DIPLOMA, URL_HISTORICO} from '../constants/index';

import {setDiploma, setHistoricoParcial} from "../actions";

import useFetch from "../hooks/useFetch";

import {containedButton} from "../utils/styles";

import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Button from "@material-ui/core/Button";
import Search from "@material-ui/icons/Search";
import {makeStyles} from '@material-ui/core/styles';
import {OutlinedInput} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    ...containedButton(theme, true, false),
    root: {
        margin: '0 auto',
        [theme.breakpoints.up('sm')]: {
            maxWidth: 304
        }
    },
    formControl: {
        marginBottom: theme.spacing(2)
    },
    inputText: {
        backgroundColor: 'white'
    },
    captchaDiv: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(2)
    }
}));
export default function FormConsultaCodigoValidacao() {
    const classes = useStyles();

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const fetch = useFetch();

    const [searchParams, setSearchParams] = useSearchParams();

    const [errorMessage, setErrorMessage] = useState('');
    const [hash, setHash] = useState(!!searchParams.get("hash") ? searchParams.get("hash") : '');

    useEffect(() => {
        let scriptToAdd = document.createElement('script');
        scriptToAdd.id = 'googleReCaptchaScript';
        scriptToAdd.type = 'text/javascript';
        scriptToAdd.src = 'https://www.google.com/recaptcha/enterprise.js';
        scriptToAdd.async = true;
        scriptToAdd.defer = true;

        document.body.appendChild(scriptToAdd);

        scriptToAdd = document.createElement('script');
        scriptToAdd.id = 'googleReCaptchaCallbackScript';
        scriptToAdd.type = 'text/javascript';
        scriptToAdd.text = 'function callbackGoogleReCaptach(token) { window.googleReCaptchaToken = token; }';

        document.head.appendChild(scriptToAdd);

        return () => {
            let scriptToRemove = document.getElementById('googleReCaptchaScript');

            document.body.removeChild(scriptToRemove);

            scriptToRemove = document.getElementById('googleReCaptchaCallbackScript');

            document.head.removeChild(scriptToRemove);
        };
    }, []);

    const onSubmit = event => {
        event.preventDefault();

        let hasError = false;

        if (_.isEmpty(hash)) {
            hasError = true;

            setErrorMessage('É obrigatório');
        }

        if (!hasError) {
            setErrorMessage('');

            if (hash.startsWith("208.208.")) {
                fetch(URL_DIPLOMA, {
                    hash: hash,
                    token: window.googleReCaptchaToken
                }, fetchedDiploma => {
                    dispatch(setDiploma(fetchedDiploma));

                    navigate('/diploma');
                });
            }else{
                fetch(URL_HISTORICO, {
                    hash: hash,
                    token: window.googleReCaptchaToken
                }, fetchedHistorico => {
                    dispatch(setHistoricoParcial(fetchedHistorico));

                    navigate('/historicoParcial');
                });
            }

            grecaptcha.enterprise.reset();
        }
    };

    const onChangeHash = event => {
        setHash(event.target.value);
    };

    return (
        <div className={classes.root}>
            <form
                noValidate
                autoComplete="off"
                onSubmit={onSubmit}>
                <FormControl variant="outlined" fullWidth className={classes.formControl}>
                    <OutlinedInput
                        name='hashInput'
                        type='text'
                        value={hash}
                        onChange={onChangeHash}
                        placeholder='Insira um código de validação...'
                        error={!!errorMessage}
                        className={classes.inputText}
                        autoFocus />
                    {!!errorMessage && (
                        <FormHelperText error>{errorMessage}</FormHelperText>
                    )}
                </FormControl>
                <div className={classes.captchaDiv}>
                    <div className='g-recaptcha' data-sitekey={GOOGLE_RECAPTCHA_KEY} data-callback='callbackGoogleReCaptach' />
                </div>
                <Button
                    variant="contained"
                    startIcon={<Search />}
                    className={classes.containedButton}
                    onClick={onSubmit}>
                    Pesquisar
                </Button>
            </form>
        </div>
    );
};